<!-- Account-level master switch. Sits above the card because it governs the whole
     feature, not any one number. -->
<div class="companion-toggle-card">
  <div class="toggle-copy">
    <h5 class="companion-title">{{ 'companion.title' | translate }}</h5>
    <p class="companion-sub">
      {{ 'companion.subtitle' | translate }}
    </p>
  </div>
  <div class="toggle-control">
    <span class="toggle-state" [class.on]="companionEnabled" *ngIf="!enabledLoading">
      {{ companionEnabled ? ('companion.enabled' | translate) : ('companion.disabled' | translate) }}
    </span>
    <span class="toggle-state" *ngIf="enabledLoading">{{ 'companion.loading' | translate }}</span>
    <label class="switch" [class.disabled]="enabledLoading || enabledSaving">
      <input
        type="checkbox"
        [checked]="companionEnabled"
        [disabled]="enabledLoading || enabledSaving"
        (change)="toggleCompanionEnabled()"
      />
      <span class="slider"></span>
    </label>
  </div>
</div>

<div class="companion-card">
  <div class="companion-header">
    <div>
      <h5 class="companion-title">{{ 'companion.cardTitle' | translate }}</h5>
      <p class="companion-sub">{{ 'companion.cardSubtitle' | translate }}</p>
    </div>
  </div>

  <!-- How to connect (email OTP inside WhatsApp) -->
  <div class="connect-steps">
    <p class="steps-title">{{ 'companion.stepsTitle' | translate }}</p>
    <ol>
      <li>{{ 'companion.step1' | translate }}<span *ngIf="botNumber"> ({{ botNumber }})</span>.</li>
      <li [innerHTML]="'companion.step2' | translate"></li>
      <li [innerHTML]="'companion.step3' | translate"></li>
    </ol>
    <a *ngIf="botWaLink" class="btn-wa" [href]="botWaLink" target="_blank" rel="noopener">{{ 'companion.messageBot' | translate }}</a>
  </div>

  <!-- Numbers list -->
  <div class="numbers-list">
    <div class="numbers-empty" *ngIf="!loading && numbers.length === 0">
      {{ 'companion.noNumbers' | translate }}
    </div>

    <div class="number-row" *ngFor="let row of numbers">
      <div class="number-main">
        <span class="number-phone">{{ row.phone_number }}</span>
        <span class="number-badge" [ngClass]="statusClass(row)">{{ statusLabel(row) }}</span>
        <span class="number-primary" *ngIf="row.is_primary">{{ 'companion.primary' | translate }}</span>
      </div>
      <div class="number-actions">
        <label class="switch" [class.disabled]="!row.is_verified">
          <input
            type="checkbox"
            [checked]="row.companion_enabled"
            [disabled]="!row.is_verified"
            (change)="toggle(row)"
          />
          <span class="slider"></span>
        </label>
        <button class="btn-remove" (click)="remove(row)" title="{{ 'common.unlink-tooltip' | translate }}">{{ 'common.unlink-tooltip' | translate }}</button>
      </div>
    </div>
  </div>
</div>
